import { BaseService } from "core/services";
import { FacilityHistoryRouteService } from "application/facility/services";

class FacilityHistoryService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityHistoryRouteService());
	}
}

export default FacilityHistoryService;